import Fetcher from 'middlewares/Fetcher';
import {
  deleteApplicationNoteSuccess,
  deleteApplicationNoteFailure,
  DeleteApplicationNoteAction,
} from './ActionCreator';
import { ApplicationNotesActionType } from './ActionTypes';
import { ApplicationNotesApi } from 'api/LoanOriginationSystem/ApplicationNotesApi';
import { ApplicationNote } from 'api/Types';

const DeleteApplicationNoteMiddleware = (api: ApplicationNotesApi) =>
  Fetcher<ApplicationNote, DeleteApplicationNoteAction>(
    ApplicationNotesActionType.DeleteApplicationNote,
    deleteApplicationNoteSuccess,
    deleteApplicationNoteFailure,
    (action) => {
      return api.deleteNote(action.payload.applicationId, action.payload.noteId);
    },
  );

export default DeleteApplicationNoteMiddleware;
